/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AddScopeOfWorkLineItemsRequest,
  AddScopeOfWorkLineItemsResponse,
  AllowanceDetailsResponse,
  AllowancesByGroupIdGetV2Params,
  ConvertLineItemsToAllowanceRequest,
  ConvertLineItemsToAllowanceResponse,
  CreateAllowanceRequest,
  CreateAllowanceResponse,
  UpdateAllowanceCompletionStatusRequest,
  UpdateAllowanceCompletionStatusResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Get an allowance's details together with all of its linked selection options.
 */
export const allowancesByGroupIdGetV2 = (
  groupId: number,
  params?: AllowancesByGroupIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AllowanceDetailsResponse>(
    { url: `/apix/v2/Allowances/${groupId}`, method: "GET", params, signal },
    options,
  );
};

export const getAllowancesByGroupIdGetV2QueryKey = (
  groupId?: number,
  params?: AllowancesByGroupIdGetV2Params,
) => {
  return [
    `/apix/v2/Allowances/${groupId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAllowancesByGroupIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof allowancesByGroupIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  groupId: number,
  params?: AllowancesByGroupIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowancesByGroupIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAllowancesByGroupIdGetV2QueryKey(groupId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof allowancesByGroupIdGetV2>>
  > = ({ signal }) =>
    allowancesByGroupIdGetV2(groupId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!groupId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof allowancesByGroupIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AllowancesByGroupIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof allowancesByGroupIdGetV2>>
>;
export type AllowancesByGroupIdGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Get an allowance's details together with all of its linked selection options.
 */

export function useAllowancesByGroupIdGetV2<
  TData = Awaited<ReturnType<typeof allowancesByGroupIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  groupId: number,
  params?: AllowancesByGroupIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowancesByGroupIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllowancesByGroupIdGetV2QueryOptions(
    groupId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Create Allowance
 */
export const allowancesCreateAllowancePostV2 = (
  createAllowanceRequest: BodyType<CreateAllowanceRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CreateAllowanceResponse>(
    {
      url: `/apix/v2/Allowances/create-allowance`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: createAllowanceRequest,
      signal,
    },
    options,
  );
};

export const getAllowancesCreateAllowancePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesCreateAllowancePostV2>>,
    TError,
    { data: BodyType<CreateAllowanceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allowancesCreateAllowancePostV2>>,
  TError,
  { data: BodyType<CreateAllowanceRequest> },
  TContext
> => {
  const mutationKey = ["allowancesCreateAllowancePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allowancesCreateAllowancePostV2>>,
    { data: BodyType<CreateAllowanceRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return allowancesCreateAllowancePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllowancesCreateAllowancePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof allowancesCreateAllowancePostV2>>
>;
export type AllowancesCreateAllowancePostV2MutationBody =
  BodyType<CreateAllowanceRequest>;
export type AllowancesCreateAllowancePostV2MutationError = ErrorType<unknown>;

/**
 * @summary Create Allowance
 */
export const useAllowancesCreateAllowancePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesCreateAllowancePostV2>>,
    TError,
    { data: BodyType<CreateAllowanceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof allowancesCreateAllowancePostV2>>,
  TError,
  { data: BodyType<CreateAllowanceRequest> },
  TContext
> => {
  const mutationOptions =
    getAllowancesCreateAllowancePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Create Selection Option Group Allowance
 */
export const allowancesCreateLineItemAndAllowancePostV2 = (
  addScopeOfWorkLineItemsRequest: BodyType<AddScopeOfWorkLineItemsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AddScopeOfWorkLineItemsResponse>(
    {
      url: `/apix/v2/Allowances/create-line-item-and-allowance`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: addScopeOfWorkLineItemsRequest,
      signal,
    },
    options,
  );
};

export const getAllowancesCreateLineItemAndAllowancePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesCreateLineItemAndAllowancePostV2>>,
    TError,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allowancesCreateLineItemAndAllowancePostV2>>,
  TError,
  { data: BodyType<AddScopeOfWorkLineItemsRequest> },
  TContext
> => {
  const mutationKey = ["allowancesCreateLineItemAndAllowancePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allowancesCreateLineItemAndAllowancePostV2>>,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return allowancesCreateLineItemAndAllowancePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllowancesCreateLineItemAndAllowancePostV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof allowancesCreateLineItemAndAllowancePostV2>>
  >;
export type AllowancesCreateLineItemAndAllowancePostV2MutationBody =
  BodyType<AddScopeOfWorkLineItemsRequest>;
export type AllowancesCreateLineItemAndAllowancePostV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Create Selection Option Group Allowance
 */
export const useAllowancesCreateLineItemAndAllowancePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesCreateLineItemAndAllowancePostV2>>,
    TError,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof allowancesCreateLineItemAndAllowancePostV2>>,
  TError,
  { data: BodyType<AddScopeOfWorkLineItemsRequest> },
  TContext
> => {
  const mutationOptions =
    getAllowancesCreateLineItemAndAllowancePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const allowancesConvertEstimateLineItemsToAllowancePostV2 = (
  convertLineItemsToAllowanceRequest: BodyType<ConvertLineItemsToAllowanceRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ConvertLineItemsToAllowanceResponse>(
    {
      url: `/apix/v2/Allowances/convert-estimate-line-items-to-allowance`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: convertLineItemsToAllowanceRequest,
      signal,
    },
    options,
  );
};

export const getAllowancesConvertEstimateLineItemsToAllowancePostV2MutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof allowancesConvertEstimateLineItemsToAllowancePostV2>
      >,
      TError,
      { data: BodyType<ConvertLineItemsToAllowanceRequest> },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof allowancesConvertEstimateLineItemsToAllowancePostV2>
    >,
    TError,
    { data: BodyType<ConvertLineItemsToAllowanceRequest> },
    TContext
  > => {
    const mutationKey = ["allowancesConvertEstimateLineItemsToAllowancePostV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof allowancesConvertEstimateLineItemsToAllowancePostV2>
      >,
      { data: BodyType<ConvertLineItemsToAllowanceRequest> }
    > = (props) => {
      const { data } = props ?? {};

      return allowancesConvertEstimateLineItemsToAllowancePostV2(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AllowancesConvertEstimateLineItemsToAllowancePostV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof allowancesConvertEstimateLineItemsToAllowancePostV2>
    >
  >;
export type AllowancesConvertEstimateLineItemsToAllowancePostV2MutationBody =
  BodyType<ConvertLineItemsToAllowanceRequest>;
export type AllowancesConvertEstimateLineItemsToAllowancePostV2MutationError =
  ErrorType<unknown>;

export const useAllowancesConvertEstimateLineItemsToAllowancePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof allowancesConvertEstimateLineItemsToAllowancePostV2>
    >,
    TError,
    { data: BodyType<ConvertLineItemsToAllowanceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof allowancesConvertEstimateLineItemsToAllowancePostV2>
  >,
  TError,
  { data: BodyType<ConvertLineItemsToAllowanceRequest> },
  TContext
> => {
  const mutationOptions =
    getAllowancesConvertEstimateLineItemsToAllowancePostV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Create Change Order Line Item as Allowance
 */
export const allowancesCreateChangeOrderLineItemAsAllowancePostV2 = (
  addScopeOfWorkLineItemsRequest: BodyType<AddScopeOfWorkLineItemsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AddScopeOfWorkLineItemsResponse>(
    {
      url: `/apix/v2/Allowances/create-change-order-line-item-as-allowance`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: addScopeOfWorkLineItemsRequest,
      signal,
    },
    options,
  );
};

export const getAllowancesCreateChangeOrderLineItemAsAllowancePostV2MutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof allowancesCreateChangeOrderLineItemAsAllowancePostV2>
      >,
      TError,
      { data: BodyType<AddScopeOfWorkLineItemsRequest> },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof allowancesCreateChangeOrderLineItemAsAllowancePostV2>
    >,
    TError,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> },
    TContext
  > => {
    const mutationKey = [
      "allowancesCreateChangeOrderLineItemAsAllowancePostV2",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof allowancesCreateChangeOrderLineItemAsAllowancePostV2>
      >,
      { data: BodyType<AddScopeOfWorkLineItemsRequest> }
    > = (props) => {
      const { data } = props ?? {};

      return allowancesCreateChangeOrderLineItemAsAllowancePostV2(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AllowancesCreateChangeOrderLineItemAsAllowancePostV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof allowancesCreateChangeOrderLineItemAsAllowancePostV2>
    >
  >;
export type AllowancesCreateChangeOrderLineItemAsAllowancePostV2MutationBody =
  BodyType<AddScopeOfWorkLineItemsRequest>;
export type AllowancesCreateChangeOrderLineItemAsAllowancePostV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Create Change Order Line Item as Allowance
 */
export const useAllowancesCreateChangeOrderLineItemAsAllowancePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof allowancesCreateChangeOrderLineItemAsAllowancePostV2>
    >,
    TError,
    { data: BodyType<AddScopeOfWorkLineItemsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof allowancesCreateChangeOrderLineItemAsAllowancePostV2>
  >,
  TError,
  { data: BodyType<AddScopeOfWorkLineItemsRequest> },
  TContext
> => {
  const mutationOptions =
    getAllowancesCreateChangeOrderLineItemAsAllowancePostV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const allowancesCompletionStatusByGroupIdPutV2 = (
  groupId: number,
  updateAllowanceCompletionStatusRequest: BodyType<UpdateAllowanceCompletionStatusRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<UpdateAllowanceCompletionStatusResponse>(
    {
      url: `/apix/v2/Allowances/${groupId}/completion-status`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: updateAllowanceCompletionStatusRequest,
    },
    options,
  );
};

export const getAllowancesCompletionStatusByGroupIdPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesCompletionStatusByGroupIdPutV2>>,
    TError,
    { groupId: number; data: BodyType<UpdateAllowanceCompletionStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allowancesCompletionStatusByGroupIdPutV2>>,
  TError,
  { groupId: number; data: BodyType<UpdateAllowanceCompletionStatusRequest> },
  TContext
> => {
  const mutationKey = ["allowancesCompletionStatusByGroupIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allowancesCompletionStatusByGroupIdPutV2>>,
    { groupId: number; data: BodyType<UpdateAllowanceCompletionStatusRequest> }
  > = (props) => {
    const { groupId, data } = props ?? {};

    return allowancesCompletionStatusByGroupIdPutV2(
      groupId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AllowancesCompletionStatusByGroupIdPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof allowancesCompletionStatusByGroupIdPutV2>>
  >;
export type AllowancesCompletionStatusByGroupIdPutV2MutationBody =
  BodyType<UpdateAllowanceCompletionStatusRequest>;
export type AllowancesCompletionStatusByGroupIdPutV2MutationError =
  ErrorType<unknown>;

export const useAllowancesCompletionStatusByGroupIdPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesCompletionStatusByGroupIdPutV2>>,
    TError,
    { groupId: number; data: BodyType<UpdateAllowanceCompletionStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof allowancesCompletionStatusByGroupIdPutV2>>,
  TError,
  { groupId: number; data: BodyType<UpdateAllowanceCompletionStatusRequest> },
  TContext
> => {
  const mutationOptions =
    getAllowancesCompletionStatusByGroupIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
